"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityCell = exports.Cell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Popover = __importStar(require("@radix-ui/react-popover"));
const lodash_1 = require("lodash");
const enums_1 = require("@bemlo/enums");
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const translate_1 = require("../../../../translate");
const consts_1 = require("../consts");
const useSchedule_1 = require("../useSchedule");
const Shift_1 = require("./Shift");
const availability_style_1 = require("../utils/availability-style");
const cellBackground = (props) => {
    if (props.disabled)
        return constants_1.Color.MEDIUM_GREY;
    if (props.weekend)
        return constants_1.Color.BACKGROUND_GREY;
    if (props.error)
        return `repeating-linear-gradient(
    -45deg, /* Angle of the gradient */
    ${constants_1.Color.LIGHT_RED}, /* First color */
    ${constants_1.Color.LIGHT_RED} 6px, /* Start of the second color */
    ${constants_1.Color.WHITE} 6px, /* Second color */
    ${constants_1.Color.WHITE} 12px /* End of the second color */
  );`;
};
exports.Cell = styled_1.default.td((props) => ({
    position: props.isTitle ? 'sticky' : 'relative',
    left: props.isTitle ? 0 : undefined,
    zIndex: props.isTitle ? consts_1.composableZIndex.cellTitle : undefined,
    background: props.isTitle ? constants_1.Color.WHITE : cellBackground(props),
    borderLeft: props.isTitle ? undefined : `1px solid ${constants_1.Color.MEDIUM_GREY}`,
    borderTop: `1px solid ${constants_1.Color.MEDIUM_GREY}`,
    color: props.isTitle ? constants_1.Color.DARK_GREY : undefined,
    fontWeight: props.isTitle ? constants_1.theme.font.weight.bold : undefined,
    userSelect: props.isTitle ? 'none' : undefined,
    boxShadow: props.rightShadow ? constants_1.theme.boxShadow.semi : undefined,
    backgroundColor: props.backgroundColor,
    ...(props.relative && { position: 'relative' }),
}));
const ContentContainer = styled_1.default.div((props) => ({
    width: '100%',
    display: 'flex',
    textAlign: 'left',
    justifyContent: props.isCompact ? 'center' : 'space-between',
    ...(props.isCompact
        ? { height: '100%' }
        : { padding: `${constants_1.theme.spacing[1.5]}px ${constants_1.theme.spacing[2]}px` }),
    alignItems: 'center',
    border: 'none',
    ...(props.border && {
        border: props.border,
        borderRadius: constants_1.theme.border.radius.normal,
        overflow: 'hidden',
    }),
    backgroundColor: props.backgroundColor,
    span: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        userSelect: 'none',
    },
    ':not(:last-child)': {
        marginBottom: constants_1.theme.spacing[1],
    },
    ...(props.hasPopover && { cursor: 'pointer' }),
}));
const Header = styled_1.default.span({
    fontWeight: constants_1.theme.font.weight.medium,
    fontSize: 12,
});
const Subtitle = styled_1.default.span({
    fontSize: 10,
    opacity: 0.75,
});
const Content = (props) => {
    const { columnWidth, availabilityPopover: PopoverContent } = (0, useSchedule_1.useSchedule)();
    const isCompact = columnWidth < 100;
    const iconSize = 'sm';
    const hasPopover = !!props.clickable && !!PopoverContent && !!props.availability.length;
    const content = ((0, jsx_runtime_1.jsxs)(ContentContainer, { as: PopoverContent ? 'button' : 'div', isCompact: isCompact, border: props.card?.border, backgroundColor: props.card?.backgroundColor, hasPopover: hasPopover, children: [!isCompact && ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { col: true, styles: { color: props.color, gap: '1px' }, children: [(0, jsx_runtime_1.jsx)(Header, { children: props.title }), (0, jsx_runtime_1.jsx)(Subtitle, { children: props.subtitle })] })), (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: props.icon, color: props.color, size: iconSize, design: props.solid ? 'solid' : 'outline' })] }));
    if (!hasPopover) {
        return content;
    }
    const candidateId = props.availability[0].candidateId;
    return ((0, jsx_runtime_1.jsxs)(Popover.Root, { children: [(0, jsx_runtime_1.jsx)(Popover.Trigger, { asChild: true, children: content }), (0, jsx_runtime_1.jsx)(Shift_1.PopoverContentWrapper, { sideOffset: 4, align: "start", side: "right", onOpenAutoFocus: (event) => event.preventDefault(), children: (0, jsx_runtime_1.jsx)(PopoverContent, { candidate: { id: candidateId }, availability: props.availability }) })] }));
};
const AvailabilityCell = (props) => {
    const t = (0, translate_1.useTranslations)();
    const style = (0, availability_style_1.useAvailabilityStyle)(props.availability);
    const noAvailabilityContent = ((0, jsx_runtime_1.jsx)(exports.Cell, { disabled: props.disabled, weekend: props.weekend, children: props.children }));
    if (!props.availability.length || props.disabled) {
        if (props.isRequired) {
            return ((0, jsx_runtime_1.jsxs)(exports.Cell, { disabled: props.disabled, weekend: props.weekend, children: [(0, jsx_runtime_1.jsx)(Content, { availability: [], icon: "CheckIcon", color: constants_1.Color.GREEN, title: t.shifts.required_day(), card: {
                            backgroundColor: constants_1.Color.WHITE,
                            border: `1px solid ${constants_1.Color.LIGHT_GREEN}`,
                        }, subtitle: "", clickable: false }), props.children] }));
        }
        return noAvailabilityContent;
    }
    const [available, notAvailability] = (0, lodash_1.partition)(props.availability, 'isAvailable');
    const isAvailable = available.length > 0;
    const isOnVacation = notAvailability.find((availability) => availability.source === enums_1.ResourceAvailabilitySource.VACATION);
    const isBlocked = notAvailability.find((availability) => availability.source === enums_1.ResourceAvailabilitySource.SCHEDULE);
    const availableShiftHours = available
        .map(({ shiftHours }) => shiftHours)
        .filter(utils_1.isTruthy)
        .map((shiftHours) => t.$shiftHours(shiftHours));
    const availableTimes = available
        .map(({ startTime, endTime }) => `${startTime} - ${endTime}`)
        .join(', ');
    const unavailableShiftHours = notAvailability
        .map(({ shiftHours }) => shiftHours)
        .filter(utils_1.isTruthy)
        .map((shiftHours) => t.$shiftHours(shiftHours));
    if (isOnVacation || isBlocked) {
        return ((0, jsx_runtime_1.jsxs)(exports.Cell, { backgroundColor: props.isOccupied ? constants_1.Color.RED : style.backgroundColor, disabled: props.disabled, children: [(0, jsx_runtime_1.jsx)(Content, { availability: [isOnVacation, isBlocked].filter(utils_1.isTruthy), icon: style.icon, color: props.isOccupied ? constants_1.Color.LIGHT_GREY : style.color, title: style.title, subtitle: style.subtitle ?? '', clickable: true }), props.children] }));
    }
    if (props.isOccupied) {
        return noAvailabilityContent;
    }
    const availableSubtitle = availableShiftHours.join(', ') || availableTimes;
    const unavailableSubtitle = unavailableShiftHours.join(', ');
    return ((0, jsx_runtime_1.jsxs)(exports.Cell, { backgroundColor: style.backgroundColor, disabled: props.disabled, children: [(0, jsx_runtime_1.jsx)(Content, { availability: isAvailable ? available : notAvailability, card: {
                    backgroundColor: style.backgroundColor,
                    border: `1px solid ${isAvailable ? constants_1.Color.LIGHT_GREEN : constants_1.Color.MEDIUM_GREY}`,
                }, icon: style.icon, color: style.color, title: style.title, subtitle: isAvailable ? availableSubtitle : unavailableSubtitle, clickable: isAvailable }), props.children] }));
};
exports.AvailabilityCell = AvailabilityCell;
